<template>
    <div>
        <h1 class="pb-4 font-weight-lighter text-center">دليلكم الشامل</h1>
        <h6 class="pb-16 text-center">سيتم إرسال الرمز  يرجى كتابته داخل الحقل</h6>
     
        <label for="code">إدخال الرمز</label>
        <v-text-field
            id="code"
            color="secondary"
            rounded
            dense
            filled
            v-model="code"
        ></v-text-field>
        <div class="text-center pt-8">
            <v-btn class="pt-5 pb-4 px-8" color="gray" rounded>تم</v-btn>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        code: ''
    })
};
</script>
